/**
 * @fileoverview Custom OpenLayers control that displays the current zoom level.
 * @module map/ZoomLevelControl
 */

/**
 * Custom OpenLayers control that shows the current zoom level in the lower-left
 * corner of the map, with one decimal place of precision.
 * @class
 * @extends ol.control.Control
 */
export class ZoomLevelControl extends ol.control.Control {
    /**
     * Creates a new ZoomLevelControl instance.
     * @param {Object} [options={}] - Control options
     * @param {HTMLElement} [options.target] - Target element to render the control into
     */
    constructor(options = {}) {
        const element = document.createElement('div');
        element.className = 'ol-zoom-level ol-unselectable ol-control';

        const label = document.createElement('span');
        label.className = 'ol-zoom-level-label';
        label.textContent = 'Z: --';
        element.appendChild(label);

        super({
            element: element,
            target: options.target
        });

        this.label = label;
    }

    /**
     * Called when the control is added to the map.
     * Sets up the view change listener to update the zoom display.
     * @param {ol.Map} map - The OpenLayers map instance
     */
    setMap(map) {
        super.setMap(map);

        if (map) {
            const view = map.getView();
            this.updateZoom(view);
            view.on('change:resolution', () => this.updateZoom(view));
        }
    }

    /**
     * Updates the zoom level display.
     * @param {ol.View} view - The map view
     */
    updateZoom(view) {
        const zoom = view.getZoom();
        if (zoom !== undefined) {
            this.label.textContent = `Z: ${zoom.toFixed(1)}`;
        }
    }
}
